import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'buyiq-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotFoundComponent { }
